/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from './Button';

import styles from '../../../styles/buttons/rounded.module.scss';

const propTypes = {
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    iconPosition: PropTypes.string,
    icon: PropTypes.node,
    children: PropTypes.node,
    secondary: PropTypes.bool,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    isDark: PropTypes.bool,
    isLarge: PropTypes.bool,
};

const defaultProps = {
    className: null,
    iconClassName: null,
    iconPosition: null,
    icon: null,
    children: null,
    secondary: false,
    loading: false,
    disabled: false,
    isDark: false,
    isLarge: false,
};

const RoundedButton = ({
    className,
    iconClassName,
    iconPosition,
    icon,
    secondary,
    loading,
    disabled,
    isDark,
    isLarge,
    children,
    ...props
}) => (
    <Button
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.secondary]: secondary,
                [styles.isDisabled]: disabled,
                [styles.isLoading]: loading,
                [styles.isDark]: isDark,
                [styles.isLarge]: isLarge,
            },
        ])}
        iconClassName={classNames([
            styles.icon,
            {
                [styles[iconPosition]]: typeof styles[iconPosition] !== 'undefined',
                [iconClassName]: iconClassName !== null,
            },
        ])}
        iconPosition={iconPosition || 'left'}
        loading={loading}
        disabled={disabled}
        icon={icon}
        {...props}
    >
        {children}
    </Button>
);

RoundedButton.propTypes = propTypes;
RoundedButton.defaultProps = defaultProps;

export default RoundedButton;
